import { useState } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { FlashcardScene } from '@/types/gameSpec';
import { SCENE_LABEL, type SceneComponentProps } from './sceneCommon';

export const FlashcardSceneView = ({
  scene,
  onAnswer,
}: SceneComponentProps<FlashcardScene>) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <Card>
      <CardContent className="p-6 space-y-4">
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          {SCENE_LABEL.flashcard}
        </div>
        <p className="text-lg font-medium">{scene.prompt}</p>

        <motion.div
          className="relative h-48 cursor-pointer rounded-lg border-2 border-primary/30 bg-card flex items-center justify-center p-6 text-center"
          onClick={() => setFlipped((f) => !f)}
          animate={{ rotateY: flipped ? 180 : 0 }}
          transition={{ duration: 0.4 }}
          style={{ transformStyle: 'preserve-3d' }}
        >
          {!flipped ? (
            <span className="text-2xl font-semibold">{scene.front}</span>
          ) : (
            <span
              className="text-xl"
              style={{ transform: 'rotateY(180deg)' }}
            >
              {scene.back}
            </span>
          )}
        </motion.div>

        <p className="text-sm text-muted-foreground text-center">
          Tap card to {flipped ? 'flip back' : 'reveal answer'}
        </p>

        {flipped && (
          <div className="flex gap-2 justify-center">
            <Button variant="outline" onClick={() => onAnswer(false, { self_rated: 'wrong' })}>
              I didn't know it
            </Button>
            <Button onClick={() => onAnswer(true, { self_rated: 'correct' })}>
              I knew it
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
